import React from "react";
import "./SharePointAndInsightPDMImplementationPage.css";
import BannerImage from "../../../assets/other_image/sharePoint.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import SharePointAndInsightPDMImplementationOverview from "./SharePointAndInsightPDMImplementationOverview";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const SharePointAndInsightPDMImplementationPage = () => {
  return (
    <section className="SharePointAndInsightPDMprocess">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="SharePoint & Insight PDM Implementation" // Pass the heading text for this page
      />
      <FloatingContactUs /> 

      <SharePointAndInsightPDMImplementationOverview />

      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="solution-page-heading">Unlock the Power :</h4>
          <h5 className="solution-subheading">
            Discover the Transformative Benefits of SharePoint & Insight PDM Implementation with NexTech!
          </h5>
          <p className="plmimplementationparagraph">
          We help customer to implement SharePoint technology for various simple to complex business requirement by adopting best practices and innovative approaches for Deployment, Integration, Configuration, Customization, Training and Support of  
          </p>
          <ul className="custom-bullets">
            <li>SharePoint 2013/2010/2007  </li>
            <li>SharePoint Foundation  </li>
            <li>WSS 3.0 SP2 /WSS 2.0  </li>
            <li>InsightPDM Platform  </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <h4 className="solution-page-heading"> Solutions</h4>
          <ul className="custom-bullets">
            <li>Intranet Sites for information and documents required internally by employees across the department </li>
            <li>Extranet Sites for file sharing to public-facing websites  </li>
            <li>Document & Process Management </li>
            <li>CAD (Solid Edge & AutoCAD) data & process management  </li>
            <li>Project & Portfolio Management  </li>
            <li>Supplier Integration and Management  </li>
            <li>Idea and Innovation management </li>
            <li>Business Intelligence  </li>
            <li>Resource management </li>
            <li>Collaboration management like meeting, conference, reviews, surveys  </li>
            <li>
            Business process like NPD/APQP/PPAP management  
            </li>
            <li>
            Customer Data and Issue management  
            </li>
          </ul>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="solution-page-heading">Why NexTech?</h4>
          <h5 className="solution-subheading">
            For SharePoint Solutions
          </h5>
          <ul className="custom-bullets">
            <li>
            In-depth understanding of SharePoint Technology   
            </li>
            <li>
            Best in class resources to handle simple to complex business requirement solution mapping in SharePoint 
            </li>
            <li>
            Proven track record of SharePoint Technology implementation and bringing value to customer business  
            </li>
            <li>
            Expertise in SharePoint Customization like web part development, UI customization, Application Integration, Custom site definition, Event Handlers, Web Services Interface, and Intelligent Document Numbering and so on. 
            </li>
          </ul>
        </div>
      </section>

      <Letsgetintouch />
    </section>
  );
};

export default SharePointAndInsightPDMImplementationPage;
